export default "__VITE_ASSET__BQnWP9Up__"